import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import styles from './style.module.less';
const MicTranscriptionDots = ({ compact = false }) => (_jsxs("div", { className: clsx(styles.wrap, compact && styles.compact), "aria-hidden": true, children: [_jsx("span", { className: styles.char, children: "." }), _jsx("span", { className: styles.char, children: "." }), _jsx("span", { className: styles.char, children: "." })] }));
export default MicTranscriptionDots;
